module.exports = __webpack_public_path__ + "static/media/HRV.7e78e78e.jpg";